<script setup>
  import { ref, computed, watchEffect } from 'vue';

  import { useSpotStore } from '@/stores/SpotStore';

  import BaseModal from './base/BaseModal.vue';
  import ModalSaveContainerToProfileStep1 from '@/components/ModalSaveContainerToProfileStep1.vue';  
  import ModalSaveContainerToProfileStep2 from '@/components/ModalSaveContainerToProfileStep2.vue';  
  
  const showModal = defineModel('showModal', { default: true });

  const props = defineProps({
    containerTypeId: {
      type: String,
      required: false
    },
    containerTypeName: {
      type: String,
      required: false
    },  
    settings: {
      type: Object,
      required: true
    }
  });

  const spotStore = useSpotStore();

  const saveContainerStep = ref(1);
  const savedContainerName = ref(`${spotStore.spotName} - ${props.containerTypeName}`);

  const showStep = computed(() => (step) => saveContainerStep.value === step);

  function closeModal() {
    showModal.value = false;
    saveContainerStep.value = 1;
  }

  watchEffect(() => {
    if (!showModal.value) saveContainerStep.value = 1;
  });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
  >

    <ModalSaveContainerToProfileStep1
      v-if="showStep(1)"
      v-model:saveContainerStep="saveContainerStep"
      v-model:savedContainerName="savedContainerName"
      :closeModal="closeModal"
      :containerTypeId="props.containerTypeId"
      :containerTypeName="props.containerTypeName"
      :settings="props.settings"
    />

    <ModalSaveContainerToProfileStep2
      v-if="showStep(2)"
      v-model:savedContainerName="savedContainerName"
      :closeModal="closeModal"
      :containerTypeId="props.containerTypeId"
      :containerTypeName="props.containerTypeName"
      :settings="props.settings"
    />  
  </BaseModal>
</template>